module.exports = __webpack_public_path__ + "static/media/SIEMENS.af4797f2.txt";